/**
 * src/components/common/ThemeToggle.jsx
 * دکمه تغییر تم دارک/لایت
 * استفاده: <ThemeToggle /> در هر جایی از UI
 */
import React, { useState, useEffect } from "react";

export function useTheme() {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("bb_theme") || "dark";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("bb_theme", theme);
  }, [theme]);

  const toggle = () => setTheme(t => t === "dark" ? "light" : "dark");

  return { theme, toggle, isDark: theme === "dark" };
}

export default function ThemeToggle({ style = {} }) {
  const { theme, toggle, isDark } = useTheme();

  return (
    <button
      onClick={toggle}
      title={isDark ? "تم روشن" : "تم تاریک"}
      style={{
        background: "none",
        border: `2px solid ${isDark ? "#ffd700" : "#3366ff"}`,
        borderRadius: "24px",
        padding: "6px 14px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: 8,
        fontFamily: "var(--font-pixel)",
        fontSize: "0.55rem",
        color: isDark ? "#ffd700" : "#3366ff",
        transition: "all 0.2s ease",
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      <span style={{ fontSize: "1rem", lineHeight: 1 }}>
        {isDark ? "☀️" : "🌙"}
      </span>
      {isDark ? "لایت" : "دارک"}
    </button>
  );
}